
import { firestore } from '../../../firebase'

import { apiSalveInColection, apiDeleteInColection, apiSyncReducer, } from 'scorpion-core';

export function salva(obj) {
    return apiSalveInColection(getColTodo(), obj);
}
export function remove(obj) {
    return apiDeleteInColection(getColTodo(), obj);
}

export function manterSincronizacao(sincronizador) {
    apiSyncReducer(getColTodo())(sincronizador)
}

function getColTodo() {
    return firestore().collection("Todo");
}





// WEBPACK FOOTER //
// ./src/routes/public/Login/api.js